import logo from "../assets/tryb-logo.svg";

/** The wordmark, with the product name under it. */
export default function Brand({ size = 65, label = "Facilitator studio", labelSize = 14 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <img src={logo} alt="tryb" style={{ width: size, height: size }} />
      {label && <div style={{ fontSize: labelSize, opacity: 0.65, marginTop: 2 }}>{label}</div>}
    </div>
  );
}
